module.exports = __webpack_public_path__ + "img/vindi_logo.7e721f99.svg";